<div class="route-component">
    <tab-control>
        <!-- Details Tab -->
        <tab-page title="Details" icon="fas fa-user-pen">
            <client-detail></client-detail>
        </tab-page>

        <!-- Policies Tab -->
        <tab-page *ngIf="clientId > 0"  title="Policies" icon="fas fa-book">
            <client-area [clientId]="clientId"></client-area>
        </tab-page>
    </tab-control>
</div>